<div class="no-results-card">
  <p class="title">
    {{ "venta-rapida.no-results.title" | translate: { query: query } }}
  </p>

  <app-main-button
    class="cta-primary"
    [label]="queryKind === 'dni'
      ? 'venta-rapida.no-results.use-as-dni'
      : 'venta-rapida.no-results.use-as-name'"
    (clicked)="onUseAsTyped()"
  />

  <app-secondary-button
    class="cta-secondary"
    [label]="'venta-rapida.no-results.full-anonymous'"
    (clicked)="onFullAnonymous()"
  />
</div>
